import axios from "./axiosInstance";

const StoreAPI = {
  getDetailsUsingDomain: (payload) => axios.get("stores/details", payload),

  // add new store
  addNewStore: (payload) => axios.post("stores/create-store", payload),

  // get list of stores with filters and pagination
  getList: (params) => axios.get("stores/", { params }),

  // get general details to show in edit page
  getGeneralDetails: (id) => axios.get(`stores/${id}`),

  // status update just by id
  updateStatus: (id) => axios.patch(`stores/status/${id}`),

  // delete item by id
  deleteItem: (id) => axios.delete(`stores/${id}`),

  // edit store details with put method, sending id and payload
  editStoreDetails: (id, payload) => axios.put(`stores/${id}`, payload),

  getSitemap: () => axios.get("stores/sitemap"),

  socialMediaDetails: () => axios.get("stores/social-media/details"),
  updateSocialMediaDetails: (payload) => axios.post("stores/social-media/", payload),

  paymentGatewayDetails: () => axios.get("stores/gateways/details"),
  updatepaymentGatewayDetails: (payload) => axios.post("stores/gateways/", payload),

  emailGatewayDetails: () => axios.get("stores/emails/details"),
  updateEmailGatewayDetails: (payload) => axios.post("stores/emails/", payload),

  shippingGatewayDetails: () => axios.get("stores/shipping/details"),
  updateShippingGatewayDetails: (payload) => axios.post("stores/shipping/", payload),

  // store dropdown for superadmin
  getListforDropdown: (params) => axios.get("stores/dropdowns", {params}),
};

export default StoreAPI;
